module.exports = __webpack_public_path__ + "img/preview-bg.b0bc3397.png";